import React, { Suspense, lazy } from 'react';

import FullScreenLoading from 'apps/home/landing/sections/fullScreenLoading';

const HomePage = lazy(() => import('apps/home/main/home'));

export default function Home(props) {
  return (
    <Suspense fallback={<FullScreenLoading />}>
      <HomePage {...props} />
    </Suspense>
  );
}
